import React, { useState, useEffect } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import BreadCrumbs from 'components/BreadCrumbs/BreadCrumbs';

const createItems = ({ displayName, targetUrl, parentCategory }) => {
    const item = { displayName, targetUrl };
    const items = [item];

    if (parentCategory) {
        items.push(...createItems(parentCategory));
    }

    return items;
};

const EMPTY_ARR = [];

const ProductBreadCrumbs = ({ parentCategory, productBreadcrumbsExperience, isRegularProductSmallView }) => {
    const [categoryBreadCrumbItems, setCategoryBreadCrumbItems] = useState(EMPTY_ARR);

    useEffect(() => {
        let nextItems = null;

        if (parentCategory) {
            nextItems = createItems(parentCategory).reverse();
        } else if (categoryBreadCrumbItems !== EMPTY_ARR) {
            nextItems = EMPTY_ARR;
        }

        if (nextItems !== null) {
            setCategoryBreadCrumbItems(nextItems);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parentCategory]);

    // Preserve the class's post-commit ordering: the ctrlr assigned digitalData
    // inside a this.setState callback (fires AFTER the state commit). Writing
    // digitalData synchronously alongside setCategoryBreadCrumbItems would land
    // the write BEFORE the next commit — one tick earlier than the class did.
    useEffect(() => {
        digitalData.page.pageInfo.breadcrumbs = categoryBreadCrumbItems;
    }, [categoryBreadCrumbItems]);

    return (
        <BreadCrumbs
            productBreadcrumbsExperience={productBreadcrumbsExperience}
            isRegularProductSmallView={isRegularProductSmallView}
            items={categoryBreadCrumbItems}
        />
    );
};

export default wrapFunctionalComponent(ProductBreadCrumbs, 'ProductBreadCrumbs');
